export enum TypographyTokensEnum {
  HEADING_1 = "Heading 1",
  HEADING_1_BOLD = "Heading 1 - Bold",
  HEADING_1_ACCENT = "Heading 1 - Accent",
  HEADING_2 = "Heading 2",
  HEADING_2_BOLD = "Heading 2 - Bold",
  HEADING_2_ACCENT = "Heading 2 - Accent",
  HEADING_3 = "Heading 3",
  HEADING_3_BOLD = "Heading 3 - Bold",
  HEADING_3_ACCENT = "Heading 3 - Accent",
  HEADING_4 = "Heading 4",
  HEADING_4_BOLD = "Heading 4 - Bold",
  HEADING_4_LIGHT = "Heading 4 - Light",
  BUTTON_LARGE = "BUTTON - LARGE",
  BUTTON_DEFAULT = "BUTTON - DEFAULT",
  BUTTON_SMALL = "BUTTON - SMALL",
  BUTTON_TEXT = "Button - Text",
  BUTTON_LINK = "Button - Link",
  BODY_1 = "Body 1",
  BODY_1_MEDIUM = "Body 1 - Medium",
  BODY_1_BOLD = "Body 1 - Bold",
  BODY_2 = "Body 2",
  BODY_2_MEDIUM = "Body 2 - Medium",
  TOOLTIP = "Tooltip",
}
